module.exports = __webpack_public_path__ + "static/media/CNXENERGY.eda740dc.txt";